import { Popover, Transition } from '@headlessui/react';
import { ChevronDownIcon } from '@heroicons/react/24/solid';
import cx from 'classnames';
import { Fragment, useState } from 'react';

import { useWebThemeContext } from '~/components/Layout/Context/useWebThemeContext';

import type { WebThemeV2 } from '~/interfaces/publication';

interface Props {
  children: React.ReactNode;
  popoverContent: React.ReactNode;
  theme: WebThemeV2;
}

const NavGroupPopover = ({ children, popoverContent, theme }: Props) => {
  const [isShowing, setIsShowing] = useState(false);
  const { classes } = useWebThemeContext();

  return (
    <Popover
      className="cursor-pointer"
      onMouseEnter={() => setIsShowing(true)}
      onMouseLeave={() => setIsShowing(false)}
    >
      {({ open }) => (
        <div className="">
          <Popover.Button
            style={{
              color: theme?.navbar_text_color || '#000',
              fontFamily: theme?.navbar_font_family,
              zIndex: 0,
            }}
            className={cx(
              classes.radius,
              'inline-flex items-center px-2 py-2 hover:bg-black/5 focus:outline-none focus-visible:ring-2',
            )}
          >
            {children}
            <div
              style={{
                color: theme?.navbar_text_color || '#000',
              }}
            >
              <ChevronDownIcon
                className={`${open ? '' : ''} ml-2 h-3 w-3 transition duration-150 ease-in-out`}
                aria-hidden="true"
              />
            </div>
          </Popover.Button>
          <Transition
            as={Fragment}
            show={isShowing}
            enter="transition ease-out duration-100"
            enterFrom="transform opacity-0 scale-95"
            enterTo="transform opacity-100 scale-100"
            leave="transition ease-in duration-75"
            leaveFrom="transform opacity-100 scale-100"
            leaveTo="transform opacity-0 scale-95"
          >
            <Popover.Panel
              style={{
                backgroundColor: theme?.navbar_background_color,
              }}
              className={cx(
                classes.radius,
                'absolute z-50 w-[180px] min-w-36 origin-top-right overflow-hidden shadow-lg ring-1 ring-black/5 focus:outline-none',
              )}
            >
              <div className="overflow-hidden rounded-lg ring-1 ring-black/5">{popoverContent}</div>
            </Popover.Panel>
          </Transition>
        </div>
      )}
    </Popover>
  );
};

export default NavGroupPopover;
